import { useSelector } from 'react-redux';
import { setupI18n } from '../../libs/i18n';
import { ReactNode } from 'react';

export interface I18nProviderProps {
  children?: ReactNode;
}

export const I18nProvider = ({ children }: I18nProviderProps) => {
  const localeConfig = useSelector((state: any) => state.localeConfig);
  setupI18n(localeConfig);
  return <>{children}</>;
};
